import { InputField } from "@rawa/ui/InputField"

/** The one property the text controls share: what shows until there is a value. */
export function PlaceholderInspector({
  placeholder,
  onEdit,
}: {
  placeholder: string
  onEdit: (edit: { placeholder: string }) => void
}) {
  return (
    <InputField
      id="field-placeholder"
      label="Placeholder text"
      value={placeholder}
      onChange={(placeholder) => onEdit({ placeholder })}
    />
  )
}
